import Vue from 'vue';

export default {
  assigneesRetrieved: (state, assignees) => {
    Vue.set(state, 'assignees', assignees);
  },
  assigneesReset: (state, assignees) => {
    Vue.set(state, 'assignees', {});
  },
  loggedInUserDatailRetrieved: (state, user) => {
    Vue.set(state, 'loggedInUserDetail', user);
  },
};
